import { useSignInFlowVariant } from '@/src/hooks/useSignInFlowVariant'
import React from 'react'
import { OtpVerificationModalWrapper } from './otpVerificationModal'

interface SignInModalWrapperProps {
    open: boolean
    onClose: () => void
    onMenuClose?: () => void
}

// Unified wrapper that selects OTP or email/password flow based on AB API
const SignInModalWrapper: React.FC<SignInModalWrapperProps> = ({ open, onClose, onMenuClose }) => {
    const { variant: signInFlowVariant } = useSignInFlowVariant()

    // if (signInFlowVariant === 'old') {
    // return <SignInModalContainer open={open} onClose={onClose} onMenuClose={onMenuClose} />
    // }

    return <OtpVerificationModalWrapper open={open} onClose={onClose} onMenuClose={onMenuClose} />
}

export { SignInModalWrapper }
export default SignInModalWrapper
